import type { ReactNode } from 'react'
import { AppLoader } from '@/lib/router/components'
import { cn } from '@/lib/utils'

interface PageProps {
  children: ReactNode
  className?: string
  isLoading?: boolean
  noPadding?: boolean
  /**
   * Pins the column to its parent's height as a flex chain. It carries no
   * bottom padding: the column is exactly as tall as the frame, so scrolling
   * happens in its children and a bottom pad would only be a dead band under
   * them. Scroll clearance for growing pages lives on PageContainer's content
   * column instead.
   */
  fullHeight?: boolean
}

export function Page({
  children,
  className,
  isLoading,
  noPadding,
  fullHeight,
}: PageProps) {
  const containerClassName = cn(
    // Only PageContainer renders Page with padding, and only for pages that
    // opted out of its own gutter — which PageContainer still applies below
    // md (px-4 sm:px-6). Padding here too doubled it on phones (28px, 40px
    // at sm), so content sat inset from the page title above it.
    !noPadding && 'md:px-6 lg:px-8',
    noPadding && 'p-0',
    fullHeight && 'flex h-full flex-col',
    className,
  )

  return (
    <div className={containerClassName}>
      {isLoading ? <AppLoader inline size="sm" /> : children}
    </div>
  )
}
